import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        requerimiento: '',
        sala: ''
    },
    mutations: {
        setRequerimiento(state, requerimiento) {
            state.requerimiento = requerimiento;
        },
        setSala(state, sala) {
            state.sala = sala;
        }
    },
    actions: {
        setRequerimiento({ commit }, requerimiento) {
            commit('setRequerimiento', requerimiento);
        },
        setSala({ commit }, sala) {
            commit('setSala', sala);
        }
    },
    // También se pueden agregar getters para obtener el valor de las variables en otras partes de la aplicación
    getters: {
        getRequerimiento: state => {
            if (state.requerimiento) {
                return state.requerimiento
            } else {
                return localStorage.getItem('requerimiento') ? localStorage.getItem('requerimiento') : "";
            }
            
        },
        getSala: state => {
            if (state.sala) {
                return state.sala
            } else {
                // console.log("Localstorage");
                return localStorage.getItem('sala') ? localStorage.getItem('sala') : "";
            }
        }
    }
})